import { ReactElement } from 'react';
import { useResourceSidebarStyles } from './ResourceSidebar.styles';
import { SummaryItem } from '../utils/resourceGroups';

type SidebarSection = {
  id: string;
  title: string;
  icon: ReactElement;
  items: SummaryItem[];
};

type ResourceSidebarProps = {
  sections: SidebarSection[];
  activeSectionId: string;
  onSectionClick: (sectionId: string) => void;
};

const ResourceSidebar = ({ sections, activeSectionId, onSectionClick }: ResourceSidebarProps) => {
  const classes = useResourceSidebarStyles();

  if (!sections.length) {
    return null;
  }

  return (
    <aside className={classes.sidebar}>
      {sections.map(section => (
        <div key={section.id} className={classes.sidebarSection}>
          <div className={classes.sidebarSectionTitle}>
            {section.icon}
            <p className={classes.sidebarSectionLabel}>{section.title}</p>
          </div>
          <div className={classes.sidebarItems}>
            {section.items.map(item => {
              const isActive = activeSectionId === item.id;

              return (
                <button
                  key={item.id}
                  type="button"
                  className={isActive ? classes.sidebarItemActive : classes.sidebarItem}
                  onClick={() => onSectionClick(item.id)}>
                  <span
                    className={
                      isActive ? classes.sidebarItemLabelActive : classes.sidebarItemLabel
                    }>
                    {item.title}
                  </span>
                  <span className={isActive ? classes.countBadgeActive : classes.countBadge}>
                    <span className={classes.countBadgeValue}>{item.count}</span>
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </aside>
  );
};

export default ResourceSidebar;
